/* istanbul ignore file */

export const PRODUCT_MEDIA_SECTION_LABEL_SINGLE = 'Product image';
export const PRODUCT_MEDIA_SECTION_LABEL_PLURAL = 'Product images';
export const KEYBOARD_INTERACTION_LABEL =
  'Press the enter key to zoom. Use keyboard arrow keys to pan image.';
